import classnames from 'classnames/bind'
import React from 'react'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type TableRow = {
  values?: string[]
}

export type TableProps = {
  className?: string
  hasDifferentLayoutInDesktop?: boolean
  thead?: TableRow
  tbody?: TableRow[]
  combinedTbody?: TableRow[]
  theadClassName?: string
  tbodyClassName?: string
  desktopTbodyClassName?: string
  firstColumnDesktopClassName?: string
}

function Table({
  className,
  thead,
  tbody,
  hasDifferentLayoutInDesktop,
  combinedTbody,
  theadClassName,
  tbodyClassName,
  desktopTbodyClassName,
  firstColumnDesktopClassName,
}: TableProps) {
  return (
    <table className={cx(css.Table, className)}>
      {thead && (
        <thead
          className={cx(
            css.thead,
            theadClassName,
            hasDifferentLayoutInDesktop ? css.hideOnLargeScreen : null,
          )}>
          <tr>
            {thead?.values?.map((value, index) => (
              <th key={`thead_td_${index}`}>{value}</th>
            ))}
          </tr>
        </thead>
      )}
      {tbody && (
        <tbody
          className={cx(
            css.tbody,
            tbodyClassName,
            hasDifferentLayoutInDesktop ? css.hideOnLargeScreen : null,
          )}>
          {tbody?.map((row, rowIndex) => (
            <tr key={`tbody_tr_${rowIndex}`}>
              {row?.values?.map((value, columnIndex) => (
                <td key={`tbody_tr_${rowIndex}_td_${columnIndex}`}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
      {hasDifferentLayoutInDesktop && combinedTbody && (
        <tbody
          className={cx(
            css.tbodyDesktop,
            desktopTbodyClassName,
            css.hideOnSmallScreen,
          )}>
          {combinedTbody?.map((row, rowIndex) => (
            <tr key={`tbody_tr_desktop_${rowIndex}`}>
              {row?.values?.map((value, columnIndex) => {
                const isFirstColumn = columnIndex === 0

                return (
                  <td
                    className={
                      isFirstColumn
                        ? cx(css.isFirst, firstColumnDesktopClassName)
                        : null
                    }
                    key={`tbody_tr_desktop_${rowIndex}_td_${columnIndex}`}>
                    {value}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      )}
    </table>
  )
}

Table.defaultProps = {}

export default Table
